import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";

import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  Container,
  DropdownItem,
  UncontrolledDropdown,
  Form,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Card,
  Nav,
  NavLink,
  NavItem,
  TabPane,
  TabContent,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import megamenuImg from "../../assets/images/megamenu-img.png";
import logo from "../../assets/images/logo.svg";
import opdcLogo from "../../assets/images/1200px-Opdc.JPG";
import logoLightSvg from "../../assets/images/logo-light.svg";

import logogorporor from "../../assets/images/draft-Logo-White.png";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

import FontSizeSelect from "../CommonForBoth/TopbarDropdown/FontSizeSelect";
import logogorkoror from "../../assets/images/draft-Logo-White.png";
import ModalLayout from "../../pages/Dashboard/ModalLayout/ModalLayout";
import { useLayOutConText } from "../../pages/Context/LayOutContext";
import { useEffect } from "react";
import { GetCookieData, GetCookieToken, GetCookieRow } from "../../pages/Cookie/GetCookie";
import axios from "axios";
import QRCode from "qrcode.react";
import FadeIn from "react-fade-in/lib/FadeIn";
import { result } from "lodash";
import { Tooltip } from "@mui/material";
import TestThaiDatePikr from "../Common/ThaiDatePicker";
import TestThaiDatePick from "../Common/ThaiDatePicker";
import ReactCardFlip from "react-card-flip";
import classnames from "classnames";
import LoadingData from "../../pages/TESTPage/LoadingData";

const API_URL = process.env.REACT_APP_API_CORS;

const Header = (props) => {
  const { setNumApprove } = useLayOutConText();

  const linkDownloadAndroid = process.env.REACT_APP_DOWNLOAD_APK;
  const linkDownloadIOS = process.env.REACT_APP_DOWNLOAD_IOS;
  const baseURL = process.env.REACT_APP_API_CORS;
  const appURL = process.env.REACT_APP_URL;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_gender = user?.user_title_name;

  const navigate = useNavigate();
  const { layOut, setLayOut } = useLayOutConText();

  const [search, setsearch] = useState(false);
  const [megaMenu, setmegaMenu] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [MenuDrp, setMenuDrp] = useState(false);
  const [notification, setNotification] = useState([]);
  const [allNoti, setAllNoti] = useState([]);
  const [checkedMenu, setCheckedMenu] = useState({
    checkedWel: false,
  });

  const [activeTab, setActiveTab] = useState("1");

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };


  const handleChange = () => {
    setCheckedMenu(!checkedMenu);
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  const handleLogout = async (name, token) => {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      token + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    setNumApprove();
    // return navigate("/login-eoffice");
    return navigate("/login");
  };

  const [userInfo, setUserInfo] = useState([]);

  const getUserInfo = async () => {
    try {
      const res = await axios.get(baseURL + "/api/users/info", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserInfo(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const [qrcode, setQRcode] = useState(false);

  const toggleQR = () => {
    setQRcode(!qrcode);
  };

  const toggleQRInModal = () => {
    setQrDownload(!qrDownload);
  };

  const [qrDownload, setQrDownload] = useState(false);

  const [isSubMenuShow, setIsSubMenuShow] = useState(false);

  useEffect(() => {
    setIsSubMenuShow(true);
  });

  const location = useLocation()?.pathname;

  const extractLink = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/;
    const match = text.match(urlRegex);
    return match ? match[0] : null;
  };

  const timeAgo = (timestamp) => {
    const currentDate = new Date().setHours(new Date().getHours() + 7);
    const previousDate = new Date(timestamp);

    const timeDifference = currentDate - previousDate;
    const minutes = Math.floor(timeDifference / (1000 * 60));

    if (minutes < 1) {
      return "ตอนนี้";
    } else if (minutes === 1) {
      return "1 นาทีที่แล้ว";
    } else if (minutes < 60) {
      return `${minutes} นาทีที่แล้ว`;
    } else if (minutes < 24 * 60) {
      const hours = Math.floor(minutes / 60);
      return `${hours} ชั่วโมงแล้ว`;
    } else {
      const days = Math.floor(minutes / (24 * 60));
      return `${days} วันที่แล้ว`;
    }
  };

  const notificationRedirect = async (redirect = null) => {
    if (redirect) {
      const redirectData = redirect.split("^");
      window.open(`${appURL}/${redirectData[0]}?${redirectData[0] + 'ID'}=${btoa(redirect)}`, '_blank');
    }
  }

  const removeNotification = async (indexToRemove, id) => {

    const getNotification = async () => {
      let params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "id",
        "order[1]": "DESC",
        "filter[user_id][0]": userInfo?.user_id,
        "filter[readed][0]": 0,
      });
      const url = `${baseURL}/notification/user`;
      let config = {
        headers: { Authorization: `Bearer ${token}` },
        params,
      };

      await axios
        .get(url, config)
        .then(async (response) => {
          setNotification(response.data.result);
        })
        .catch((error) => console.error("Error:", error));
    };

    // const updatedElements = notification?.result?.filter(
    //   (_, index) => index !== indexToRemove
    // );

    let url = `${baseURL}/notification/edit/${id}`;
    let config = { headers: { Authorization: `Bearer ${token}` } };
    await axios
      .put(url, { readed: 1 }, config)
      .then(async (response) => { })
      .catch((error) => console.error("Error:", error));

    setTimeout(() => {
      // setNotification({ ...notification, result: updatedElements });
      if (userInfo?.user_id) getNotification();
    }, 300);
  };

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingAnimeTion, setLoadingAnimeTion] = useState(false);
  const [showLoadMoreMenu, setShowLaodMoreMenu] = useState(true);


  const getNotification = async (task = null) => {
    let params = new URLSearchParams({
      // page: task ? 1 : page,
      page: page,
      size: task ? 5 : 10,
      "order[0]": "id",
      "order[1]": "DESC",
      "filter[user_id][0]": userInfo?.user_id,
      "filter[readed][0]": 0,
    });
    if (task) {
      params.delete("filter[readed][0]", 0)
    }
    const url = `${baseURL}/notification/user`;
    let config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    setLoading(true);
    await axios
      .get(url, config)
      .then(async (response) => {
        if (task) {
          setLoadingAnimeTion(true)
          setTimeout(() => {
            setLoadingAnimeTion(false)
            setAllNoti(response.data)
            setLoading(false);
          }, 1000);
        } else {
          if (page === 1) {
            setTimeout(() => {
              setNotification(response.data.result);
              setLoading(false);
            }, 500);
          } else {
            setTimeout(() => {
              setNotification(prevRecords => [...prevRecords, ...response.data.result]);
              setLoading(false);
            }, 500);
          }
        }
        response.data.result?.length === 0 && setShowLaodMoreMenu(false)
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleLogoutEoffice = async () => {
    try {
      const userEofficeAccessToken = GetCookieRow('userEofficeAccessToken');
      if (userEofficeAccessToken) {
        axios.get('https://oidc.eoffice.go.th/logout?redirect_url=smarts.opdc.go.th/login-eoffice', {
          headers: { Authorization: userEofficeAccessToken },
          maxRedirects: 5 // Set the maximum number of redirects if needed
        })
          .then(async response => {
            await handleLogout("userData", "userToken");
            window.location.href = response.request.responseURL
          })
          .catch(error => {
            console.log('Error:', error);
          });
      } else {
        await handleLogout("userData", "userToken");
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (userInfo?.user_id) getNotification();

    const intervalId = setInterval(getNotification, 60000);
    return () => clearInterval(intervalId);
  }, [userInfo]);

  const [searchName, setSearchName] = useState("");
  const [result, setResult] = useState([]);

  const fetchData = () => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[deleted][0]": "1",
      "filter[user_id_status][0]": "1",
      search: searchName,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then((response) => {
        setResult(() => response.data.result);
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleSearch = (value) => {
    fetchData();
    openModal();
  };

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  function emptyAndNullSafe(input) {
    return input !== "" && input !== null ? input : "-";
  }

  const [notiModal, setNotiModal] = useState(false);

  const notiHistoryModal = () => {
    return (
      <Modal isOpen={notiModal} centered toggle={() => { setNotiModal(false); setAllNoti([]); setPage(1) }} size="lg">
        <ModalHeader toggle={() => { setNotiModal(false); setAllNoti([]); setPage(1) }}>การแจ้งเตือนทั้งหมด</ModalHeader>
        <ModalBody>
          {loadingAnimeTion ?
            <LoadingData />
            :
            <Fragment>
              {allNoti?.result ? allNoti?.result?.map((x, i) => {
                return (
                  <Fragment key={`index_${i}`}>
                    <div
                      key={i}
                      className="notification-item"
                      href={extractLink(x?.message)}
                      onClick={async (e) => {
                        await removeNotification(i, x?.id);
                        await notificationRedirect(x?.redirect_uri || null);
                      }
                      }
                      data-readed={x.readed}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="d-flex">
                        <div className="avatar-xs me-3">
                          <span
                            className={`avatar-title rounded-circle font-size-16`}
                            style={{
                              minWidth: "32px",
                              backgroundColor: x.readed === 0 ? '#556ee6' : 'rgb(159, 159, 159)'
                            }}
                          >
                            <i className="fa-solid fa-bell-on"></i>
                          </span>
                        </div>
                        <div className="flex-grow-1"
                          style={{
                            color: x.readed === 0 ? 'rgb(42, 48, 66)' : 'rgb(159, 159, 159)'
                          }}>
                          <div className="font-size-12">
                            <p className="mb-1">{x?.message}</p>
                            <p className="mb-0">
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              {timeAgo(x?.created_date)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )
              }) : <h4 className="text-center">ไม่มีข้อมูล</h4>
              }
              <Row className="mt-2">
                <Col className="d-flex justify-content-center">
                  <Pagination aria-label="Page navigation example">
                    <PaginationItem disabled={page === 1}>
                      <PaginationLink onClick={() => setPage(1)}>
                        หน้าแรก
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={page === 1}>
                      <PaginationLink onClick={() => setPage(page - 1)}>
                        ย้อนกลับ
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink>หน้า {page} จาก {allNoti?.info?.totalPage}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={page === allNoti?.info?.totalPage}>
                      <PaginationLink onClick={() => setPage(allNoti?.info?.currentPage + 1)}>
                        ถัดไป
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={page === allNoti?.info?.totalPage}>
                      <PaginationLink onClick={() => setPage(allNoti?.info?.totalPage)}>
                        หน้าสุดท้าย
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
            </Fragment>
          }

        </ModalBody>
      </Modal>
    )
  }

  useEffect(() => {
    if (notiModal) {
      getNotification('AllNoti')
    }
  }, [notiModal])

  useEffect(() => {
    if (notiModal) {
      getNotification('AllNoti')
    } else {
      getNotification()
    }
  }, [page])


  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logogorkoror} alt="" height="19" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <Row>
              <Col xs={9} md={12} lg={12} xl={12}>
                <InputGroup className="m-3">
                  <Input
                    placeholder="ค้นหาเจ้าหน้าที่"
                    onChange={(e) => {
                      setSearchName(e.target.value.trim());
                    }}
                    onKeyDown={handleKeyDown}
                    className=""
                  />
                  <Button
                    onClick={() => {
                      handleSearch();
                    }}
                    style={{ backgroundColor: "#556ee6" }}
                  >
                    <i className="fa-sharp fa-solid fa-magnifying-glass"></i>
                  </Button>
                </InputGroup>
              </Col>
            </Row>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="d-inline-block d-lg-inline-block d-sm-none d-none ms-2">
              <Dropdown
                className="d-none d-lg-inline-block ms-1"
                isOpen={socialDrp}
                toggle={() => {
                  setsocialDrp(!socialDrp);
                }}
              >
                <DropdownToggle
                  className="btn header-item noti-icon "
                  tag="button"
                >
                  <i className="bx bx-bell"></i>
                  {notification?.filter(item => item.readed === 0).length > 0 && <span
                    className="badge bg-danger rounded-pill"
                    style={{ paddingTop: "4px" }}
                  >
                    {
                      notification?.filter(item => item.readed === 0)
                        ? notification?.filter(item => item.readed === 0).length
                        : 0
                    }
                  </span>}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-2" style={{ minHeight: "100px", maxHeight: "550px" }}>
                  <Row className="align-items-center p-1">
                    <Col>
                      <h6 className="m-0">
                        แจ้งเตือน{" "}
                        {notification?.filter(item => item.readed === 0).length > 0 && <span
                          className="badge bg-danger rounded-pill"
                          style={{ paddingTop: "4px" }}
                        >
                          {notification?.filter(item => item.readed === 0)
                            ? notification?.filter(item => item.readed === 0).length
                            : 0}
                        </span>}
                      </h6>
                    </Col>
                    <Col className="text-end">
                      <Link onClick={() => { setNotiModal(true); setsocialDrp(!socialDrp) }}>ดูทั้งหมด</Link>
                    </Col>
                  </Row>
                  <Row className="overflow-auto" style={{ minHeight: "100px", maxHeight: "500px" }}>
                    <div>
                      {notification ? (
                        notification?.map((x, i) => (
                          <div
                            key={i}
                            className="notification-item"
                            href={extractLink(x?.message)}
                            onClick={async (e) => {
                              await removeNotification(i, x?.id);
                              await notificationRedirect(x?.redirect_uri || null);
                            }
                            }
                            data-readed={x.readed}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex">
                              <div className="avatar-xs me-3">
                                <span
                                  className={`avatar-title rounded-circle font-size-16`}
                                  style={{
                                    minWidth: "32px",
                                    backgroundColor: x.readed === 0 ? '#556ee6' : 'rgb(159, 159, 159)'
                                  }}
                                >
                                  <i className="fa-solid fa-bell-on"></i>
                                </span>
                              </div>
                              <div className="flex-grow-1"
                                style={{
                                  color: x.readed === 0 ? 'rgb(42, 48, 66)' : 'rgb(159, 159, 159)'
                                }}>
                                <div className="font-size-12">
                                  <p className="mb-1">{x?.message}</p>
                                  <p className="mb-0">
                                    <i className="mdi mdi-clock-outline"></i>{" "}
                                    {timeAgo(x?.created_date)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <a className="text-reset notification-item">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <div className="font-size-12 text-muted">
                                <p className="mb-1">ไม่มีแจ้งเตือน</p>
                              </div>
                            </div>
                          </div>
                        </a>
                      )}
                      {loading && <div>กำลังโหลด...</div>}
                      {showLoadMoreMenu && <div
                        className="notification-item"
                        onClick={async (e) => {
                          setPage(prevPage => prevPage + 1);
                        }
                        }
                        data-readed={false}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex">
                          <div className="flex-grow-1"
                            style={{
                              color: 'rgb(42, 48, 66)'
                            }}>
                            <div className="font-size-12">
                              <p className="mb-0">
                                โหลดเพิ่มเติม...
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                  </Row>
                </DropdownMenu>
              </Dropdown>
              {notiHistoryModal()}
              <button
                type="button"
                onClick={() => {
                  toggleQR();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="fa-solid fa-qrcode font-size-16"></i>
              </button>
            </div>
            <Modal centered isOpen={qrcode} toggle={toggleQR}>
              <ModalBody>
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      <h5> ดาวน์โหลด android </h5>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      <h5> ดาวน์โหลด ios </h5>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane TabPane tabId="1">
                    <div className="col-12 d-flex justify-content-center py-5">
                      <QRCode
                        imageSettings={{
                          src: "https://cdn-icons-png.flaticon.com/512/174/174836.png",
                          x: undefined,
                          y: undefined,
                          height: 30,
                          width: 30,
                          excavate: true,
                        }}
                        value={linkDownloadAndroid}
                        size={220}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div className="col-12 d-flex justify-content-center py-5">
                      <QRCode
                        imageSettings={{
                          src: "https://www.freeiconspng.com/uploads/apple-ios-png-12.png",
                          x: undefined,
                          y: undefined,
                          height: 30,
                          width: 30,
                          excavate: true,
                        }}
                        value={linkDownloadIOS}
                        size={220}
                      />
                    </div>
                  </TabPane>
                </TabContent>
              </ModalBody>
              <ModalFooter>
                <Button className="mx-2" color="danger" onClick={() => { toggleQR() }}>
                  ปิด
                </Button>
              </ModalFooter>
            </Modal>
            <div className="dropdown d-inline-block d-xxl-inline-block d-sm-none d-none ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>
            <ProfileMenu picture={userInfo?.user_pic} />
            <button
              style={{}}
              onClick={() => {
                handleLogoutEoffice();
              }}
              color="primary"
              className="btn header-item noti-icon right-bar-toggle"
            >
              <i className="fa-solid fa-right-from-bracket d-block d-sm-none"></i>
              <strong className="d-none d-sm-block">ออกจากระบบ</strong>
            </button>
          </div>
        </div>
      </header>
      <Modal
        isOpen={showModal}
        toggle={() => {
          closeModal();
        }}
        size="lg"
        centered={true}
      >
        <ModalHeader
          toggle={() => {
            closeModal();
          }}
        >
          ผลการค้นหา {`"${searchName}"`}
        </ModalHeader>
        <ModalBody>
          {result.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center fs-5">
                ไม่มีข้อมูล
              </td>
            </tr>
          ) : (
            result.map((i, index) => {
              return i.deleted === 1 ? (
                <Card className="border p-3">
                  <Row>
                    {i.user_pic !== null ? (
                      <Col
                        lg={3}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{ width: "75px", height: "100px" }}
                          src={i.user_pic && i.user_pic.startsWith("./public") ? API_URL + i.user_pic.replace("./public", "") : i.user_pic }
                          alt="รูปเจ้าหน้าที่"
                        />
                      </Col>
                    ) : (
                      <Col
                        lg={3}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                          src={opdcLogo}
                          alt="รูปเจ้าหน้าที่"
                        />
                      </Col>
                    )}
                    <Col
                      lg={9}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      <div>
                        <p>ชื่อ : {emptyAndNullSafe(i.user_name)}</p>
                        <p>สังกัด : {emptyAndNullSafe(i.cont_to)}</p>
                        <p>ตำแหน่ง : {emptyAndNullSafe(i.user_position_name)}</p>
                        <p>หมายเลขภายใน : {emptyAndNullSafe(i.user_intercom)}</p>
                        <p className="mb-0">
                          อีเมล : {emptyAndNullSafe(i.user_email)}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Card>
              ) : (
                ""
              );
            })
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
